import { render, staticRenderFns } from "./TopCard.vue?vue&type=template&id=9ddabc1c"
import script from "./TopCard.vue?vue&type=script&lang=js"
export * from "./TopCard.vue?vue&type=script&lang=js"
import style0 from "./TopCard.vue?vue&type=style&index=0&id=9ddabc1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports